export const SET_STORE_REQUESTS_LIST = 'SET_STORE_REQUESTS_LIST'
